import { Navigate, RouteObject } from 'react-router';
import lazyImport from '~/utils/lazyImport';

const CompanyData = lazyImport(() => import('~/views/invoices/profile/CompanyData'));
const DefaultValues = lazyImport(() => import('~/views/invoices/profile/DefaultValues'));
const DocumentSectionals = lazyImport(() => import('~/views/invoices/profile/DocumentSectionals'));

export const invoicesProfileRoutes: RouteObject[] = [
  {
    index: true,
    element: <Navigate to="company-data" replace />,
  },
  {
    path: 'company-data',
    element: <CompanyData />,
  },
  {
    path: 'defaults',
    element: <DefaultValues />,
  },
  {
    path: 'sectionals',
    element: <DocumentSectionals />,
  },
];
